declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Window {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		fbq?: (...args: any[]) => void;
	}
}

/**
 * Tracks a Meta Pixel CompleteRegistration event when a user completes a signature.
 * This standard event helps optimize ad conversions for completed registrations.
 */
const trackCompleteRegistration = (params?: Record<string, unknown>): void => {
	if (typeof window !== 'undefined' && window.fbq) {
		window.fbq('track', 'CompleteRegistration', params);
	}
};

type PurchaseParams = {
	value: number;
	currency: string;
};

/**
 * Tracks a Meta Pixel Purchase event when a user completes a monetary contribution
 * to a petition. This standard event gives Meta revenue signal to optimize ad spend.
 */
const trackPurchase = ({ value, currency }: PurchaseParams): void => {
	if (typeof window !== 'undefined' && window.fbq) {
		window.fbq('track', 'Purchase', { value, currency });
	}
};

type SubscribeParams = {
	value: number;
	currency: string;
	predictedLtv: number | undefined;
};

/**
 * Tracks a Meta Pixel Subscribe event when a user acquires a PPMU membership.
 * predicted_ltv is omitted (not sent as 0) when no LTV data is configured for
 * the subscriber's country.
 */
const trackSubscribe = ({ value, currency, predictedLtv }: SubscribeParams): void => {
	if (typeof window !== 'undefined' && window.fbq) {
		window.fbq('track', 'Subscribe', {
			value,
			currency,
			...(predictedLtv !== undefined ? { predicted_ltv: predictedLtv } : {}),
		});
	}
};

export const metaPixelTracking = {
	trackCompleteRegistration,
	trackPurchase,
	trackSubscribe,
};
